import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, Subject as RxjsSubject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { File } from '../../../../shared/models/file';
import { IParentEntity } from 'app/shared/interfaces/entity';
import { TaskType } from 'app/shared/models/task-type';
import { Subject } from 'app/shared/models/subject';
import { AttachmentService } from 'app/shared/services/attachment.service';
import { SubjectUrl } from 'app/shared/models/subject-url';
import { EventService } from 'app/shared/services/event.service';
import { HyperLawService } from 'app/shared/services/hyper-law.service';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
    selector: 'file-list',
    templateUrl: './file-list.component.html',
    styleUrls: ['./file-list.component.scss'],
    animations: fuseAnimations,
})
export class FileListComponent implements OnInit, OnDestroy {
    files: (File | SubjectUrl)[] = [];
    @Input() selectedItems: number[] = [];
    @Input() selectAllClicked: RxjsSubject<void>; 
    @Input() exportToCasePreparationFileClicked: RxjsSubject<void>;

    onChanged: Subscription;
    onSelected: Subscription;
    notifications: Subscription;
    onSelectAllClicked: Subscription;
    onExportToCasePreparationFileClicked: Subscription;

    onSubjectDashboard = false;

    _parent: IParentEntity;

    @Input() inWidget: boolean;

    @Input() readOnly: boolean;


    @Input() set parent(val: IParentEntity) {
        if (val) {
            this.onSubjectDashboard = true;
            this.SetParent(val);
        }
    }

    @Input() set subject(val: Subject) {
        if (val) {
            this.SetParent({ id: val.id, uid: val.uid, type: val.isReferral ? 'referral' : 'subject', summary: val.summary });
        }
    }

    @Input() set taskType(val: TaskType) {
        if (val) {
            this.SetParent({ id: val.id, uid: val.uid, type: 'taskType', summary: val.name });
        }
    }

    SetParent(parent: IParentEntity) {
        this._parent = parent;        
        this.attachmentService.getAttachments(parent);
    }

    constructor(
        private attachmentService: AttachmentService,
        private eventService: EventService,
        private hyperLawService: HyperLawService,
    ) {}

    ngOnInit() {
        this.onChanged = this.attachmentService.onChanged.subscribe((items) => {    
            if (this._parent) {
                this.files = items.filter(item => !item.isDirectory);
            }
            this.attachmentService.selectedFiles.next([]);
        });

        this.notifications = this.eventService.onFilesUpdated.subscribe(_ => {            
            this.attachmentService.getAttachments(this._parent);
        });

        this.onSelectAllClicked = this.selectAllClicked.subscribe(() => {
            this.attachmentService.toggleSelectAll(this.files);
        });

        this.onExportToCasePreparationFileClicked = this.exportToCasePreparationFileClicked.subscribe(() => {
          this.hyperLawService.exportToCaseBtnClicked(this._parent.uid, this.attachmentService.selectedFiles.value);
        });
      }

    ngOnDestroy() {
        if (this.onChanged) { this.onChanged.unsubscribe(); }
        if (this.onSelected) { this.onSelected.unsubscribe(); }
        if (this.notifications) { this.notifications.unsubscribe(); }
        if (this.onSelectAllClicked) { this.onSelectAllClicked.unsubscribe(); }
        if (this.onExportToCasePreparationFileClicked) { this.onExportToCasePreparationFileClicked.unsubscribe(); }
    }
}
